import styles from "./style.module.css";

// Creator : Team d - oriya
export default function SignButton({ disable, onClick, content, type, style = {} }) {
  return (
    <div className={`${styles["btn-box"]} `}>
      <button style={style} onClick={onClick} disabled={disable} className={styles["sign-button"]} type={type}>
        {content.toUpperCase()}
      </button>
    </div>
  );
}
